import { rules } from '~/markdown'
import { configure } from '~/ui/components/markdown'

configure({
  extraRules: rules,
})